import React from 'react';
import {
  IIconProps,
  SvgPaymentAmex,
  SvgPaymentCreditCardGeneric,
  SvgPaymentDinersClub,
  SvgPaymentDiscover,
  SvgPaymentJcb,
  SvgPaymentMastercard,
  SvgPaymentVisa,
} from '@grubhubprod/gh-cookbook-react';
import { normalizeCardType } from 'src/utilities/string-utils';

export enum CreditCardBrand {
  VISA = 'visa',
  AMEX = 'amex',
  AMERICAN_EXPRESS = 'americanexpress',
  MASTERCARD = 'mastercard',
  UNIONPAY = 'unionpay',
  DISCOVER = 'discover',
  JCB = 'jcb',
  DINERS = 'diners',
}

export interface ICreditCardIconProps extends IIconProps {
  cardBrand: string;
}

export function CreditCardIcon({
  cardBrand,
  size = '32px',
}: ICreditCardIconProps): JSX.Element {
  const normalizedCardBrand = normalizeCardType(cardBrand);

  switch (normalizedCardBrand) {
    case CreditCardBrand.AMERICAN_EXPRESS:
    case CreditCardBrand.AMEX:
      return <SvgPaymentAmex size={size} />;
    case CreditCardBrand.VISA:
      return <SvgPaymentVisa size={size} />;
    case CreditCardBrand.MASTERCARD:
      return <SvgPaymentMastercard size={size} />;
    case CreditCardBrand.DISCOVER:
      return <SvgPaymentDiscover size={size} />;
    case CreditCardBrand.JCB:
      return <SvgPaymentJcb size={size} />;
    case CreditCardBrand.DINERS:
      return <SvgPaymentDinersClub size={size} />;
    default:
      return <SvgPaymentCreditCardGeneric size={size} />;
  }
}
